export type NotificationVariant = "success" | "info" | "error" | "warning";

type VariantStyle = {
	bg: string;
	border: string;
	title: string;
	titleHover: string;
	icon: string;
	unreadContainer: string;
	unreadIndicator: string;
	unreadBadge: string;
	unreadHover: string;
};

export const typeStyles: Record<NotificationVariant, VariantStyle> = {
	success: {
		bg: "bg-green-50",
		border: "border-green-200",
		title: "text-green-700",
		titleHover: "group-hover:text-green-800",
		icon: "text-green-500",
		unreadContainer: "border-l-4 border-l-green-500 bg-green-50/30 shadow-md",
		unreadIndicator: "bg-green-500 animate-pulse",
		unreadBadge: "bg-green-100 text-green-700",
		unreadHover: "hover:bg-green-50/50 hover:shadow-lg",
	},
	info: {
		bg: "bg-blue-50",
		border: "border-blue-200",
		title: "text-blue-700",
		titleHover: "group-hover:text-blue-800",
		icon: "text-blue-500",
		unreadContainer: "border-l-4 border-l-blue-500 bg-blue-50/30 shadow-md",
		unreadIndicator: "bg-blue-500 animate-pulse",
		unreadBadge: "bg-blue-100 text-blue-700",
		unreadHover: "hover:bg-blue-50/50 hover:shadow-lg",
	},
	error: {
		bg: "bg-red-50",
		border: "border-red-200",
		title: "text-red-700",
		titleHover: "group-hover:text-red-800",
		icon: "text-red-500",
		unreadContainer: "border-l-4 border-l-red-500 bg-red-50/30 shadow-md",
		unreadIndicator: "bg-red-500 animate-pulse",
		unreadBadge: "bg-red-100 text-red-700",
		unreadHover: "hover:bg-red-50/50 hover:shadow-lg",
	},
	warning: {
		bg: "bg-yellow-50",
		border: "border-yellow-200",
		title: "text-yellow-700",
		titleHover: "group-hover:text-yellow-800",
		icon: "text-yellow-500",
		unreadContainer: "border-l-4 border-l-yellow-500 bg-yellow-50/30 shadow-md",
		unreadIndicator: "bg-yellow-500 animate-pulse",
		unreadBadge: "bg-yellow-100 text-yellow-700",
		unreadHover: "hover:bg-yellow-50/50 hover:shadow-lg",
	},
};

const DEFAULT_VARIANT: NotificationVariant = "info";

export const getNotificationVariantStyle = (variant: string): VariantStyle => {
	if (variant in typeStyles) {
		return typeStyles[variant as NotificationVariant];
	}
	return typeStyles[DEFAULT_VARIANT];
};

export const unreadStyles = {
	title: "font-bold",
};
